import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col, Nav, Tab, Breadcrumb } from "react-bootstrap";
import StudioMediaCard from '../../Studio_header/MediaCardSec/StudioMediaCard/StudioMediaCard'
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../utils/context";
import { mediaSpace, mediaSpaceVendor } from "../../../utils/apis/MediaSpace/MediaSpace";
// import { SpaceStidio } from "../../utils/apis/Home/Homeapi";
import { AllVendors, SpaceStidio } from "../../../utils/apis/Home/Homeapi";
import './vendorscardstab.css'
import Pagination from "react-bootstrap/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSliders,
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import FilterModal from "../../Studio_header/MediaCardSec/FilterModal/FilterModal";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import Pagination_Holder from "../../common-section/Pagination_Holder/Pagination_Holder";

const Vendor_cards = (
  id,
) => {

  const { vendor_name, city_id } = useParams()
  const { IMG_URL, setSelectedVendorID, selectedVendorID, secondBreadCrum,selectedCityID,setSelectedCityID } = useContext(Context);

  console.log("selectedCityID",selectedCityID)



 


  const [dataLink, setDataLink] = useState();
  const [currentPage, setcurrentPage] = useState();

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [data, setData] = useState();

  const [location, setLocation] = useState("");
  const [price, setPrice] = useState("");
  const [rating, setRating] = useState("");
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [isFiltered, setisFiltered] = useState(false);
  const [filteredModalKey, setfilteredModalKey] = useState(0);




  const getAllVendorsData = async (vendor_name = "") => {
    console.log("vendor api called")
    const res = await AllVendors(vendor_name);
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };



  const allServiceApiFunction = async (id,city_id = "") => {

    console.log("allServiceApiFunction",id,city_id)

    const res = await mediaSpaceVendor(onPageChange, id, "", location, price, rating,city_id);
    if (res?.success) {
      setFilteredCategories(res?.data);
      settotalPages(res?.data?.totalPages);
      setcurrentPage(res?.data?.currentPage)
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };




  useEffect(() => {
    if (data?.length > 0) {
      handleVendorSelection(data[0]?.id)
    }
  }, [data])


  console.log("selectedVendorID", selectedVendorID)

  useEffect(() => {

    if (data?.length > 0) {

      console.log("selectedVendorID", selectedVendorID)

      allServiceApiFunction(selectedVendorID, selectedCityID ? selectedCityID  : city_id)
    }
  }, [id, onPageChange, location, price, rating]);



  useEffect(() => {

    if (selectedVendorID != undefined && selectedVendorID !== "") {
      allServiceApiFunction(selectedVendorID, selectedCityID ? selectedCityID  : city_id)
    }

  }, [selectedVendorID])






  useEffect(() => {
    console.log("vendor_name:", vendor_name, "city_id:", city_id);


    let searchVendor = "";
    let cityIdParam = "";  

    if (vendor_name && !isNaN(vendor_name)) {      
      cityIdParam = vendor_name;
    } else {      
      searchVendor = vendor_name || "";
    }
    if (city_id) {
      cityIdParam = city_id;
    }

    console.log("cityIdParam",cityIdParam)

    setSelectedCityID(cityIdParam)


    getAllVendorsData(searchVendor);

  

    if (selectedVendorID && selectedCityID) {
      allServiceApiFunction(selectedVendorID, selectedCityID ? selectedCityID  : city_id);
    }

  }, [vendor_name, city_id]);


  useEffect(() => {
    if (selectedCityID) {
      allServiceApiFunction(selectedVendorID, selectedCityID ? selectedCityID  : city_id);
    }
  }, [selectedCityID]);


  console.log("vendor_list", data)

  console.log("filteredCategories", filteredCategories)

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const handleVendorSelection = (vendorID) => {
    clearFilter()
    setSelectedVendorID(vendorID); // Persist the value
    allServiceApiFunction(vendorID,selectedCityID);
  };


  const clearFilter = () => {
    setRating("");
    setPrice("");
    setLocation("");
    setisFiltered(false)
    setfilteredModalKey((count) => count + 1)
  }

  return (
    <>
      <section className='Vendor_cards_Sec'>
        <div className='container'>
          <div className='background-card'>

            {data?.length > 0 ? (
              <div className='row'>

                <div className="Breadcrumb_comp">
                  <Breadcrumb>
                    <Breadcrumb.Item className="firstbread" href="/">
                      Home <FontAwesomeIcon icon={faChevronRight} />{" "}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active
                    >
                      {secondBreadCrum}
                      {/* {data?.data?.[0]?.category?.name}  */}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>

                <div className='col-xl-3'>
                  <div className="vendorscardstab">
                    <div className="studiodrop">
                      <div className="drop-menu">
                        {data?.map((val, index) => (
                          <div className="dropdown-item">
                            <div className="d-flex"
                              onClick={() => handleVendorSelection(val?.id)}

                            >
                              <div className="img-div">
                                <img className="menuimg" src={IMG_URL + val?.image} />
                              </div>
                              <div className="menunamediv my-auto">
                                <p>{val?.first_name}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-xl-9'>

                  <div className="exphallstrip">



                    <div className="row">
                      <div className="col-8">
                        <p className="expactp">Explore Hall</p>
                      </div>
                      <div className="col-4 text-end">
                        <div
                          className="slider-icon "

                        >
                          <FontAwesomeIcon icon={faSliders} className="slide-fa" onClick={() => {
                            setModalShow(true)
                          }} />
                          {isFiltered ? (<FontAwesomeIcon icon={faArrowRotateLeft} className="reload-fa" onClick={clearFilter} />) : null}
                        </div>


                        <div >

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {filteredCategories?.data?.length > 0 ? (
                      <>
                        {
                          filteredCategories?.data?.map((item, index) => (
                            <Col key={index} xxl={4} xl={4} lg={4} md={6} sm={6}>
                              <Link to={`/service-inner/${item?.id}`}>
                                <StudioMediaCard
                                  image={
                                    IMG_URL + item?.services_images
                                      ?.[0]?.images

                                  }
                                  LocationText={item?.address}
                                  Title={item?.category?.name}
                                  numberRate={
                                    item?.averageRating > 0
                                      ? item?.averageRating
                                      : 0
                                  }
                                  isPreBooked={item?.prebooked}
                                  isBooked={item?.booked}
                                />
                              </Link>
                            </Col>
                          ))
                        }
                        <div className="media-card-sec mt-5">
                          
                        <Pagination_Holder
                            onPageChange={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                          />
                          {/* <Pagination className="justify-content-center">
                            <Pagination.Prev
                              disabled={onPageChange === 1}
                              onClick={() => handlePageChange(onPageChange - 1)}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="page-link-prev"
                              />
                            </Pagination.Prev>

                            {paginationItems}

                            <Pagination.Next
                              disabled={onPageChange === totalPages}
                              onClick={() => handlePageChange(onPageChange + 1)}
                            >
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="page-link-next"
                              />
                            </Pagination.Next>
                          </Pagination> */}
                        </div>
                      </>
                    ) : (
                      <div
                        className="text-center"
                        style={{
                          fontWeight: "bold",
                          padding: "20px",
                          color: "#000",
                        }}
                      >
                        No Data Available
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) :
              (
                <div
                  className="text-center"
                  style={{
                    fontWeight: "bold",
                    padding: "20px",
                    color: "#000",
                  }}
                >
                  No Data Available
                </div>
              )}


          </div>
        </div>
      </section>


      <FilterModal
        key={(filteredModalKey)}
        show={modalShow}
        location={location}
        setLocation={setLocation}
        price={price}
        setPrice={setPrice}
        rating={rating}
        setRating={setRating}
        onHide={() => setModalShow(false)}
        setisFiltered={setisFiltered}
      />
    </>
  )
}

export default Vendor_cards